import { Component, signal, OnInit, inject, effect, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './header.html',
})
export class HeaderComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private destroyRef = inject(DestroyRef);

  userDisplayName = signal<string>('Usuario');
  userIsAnonymous = signal<boolean>(false);

  constructor() {
    this.authService.user$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      const user = this.authService.getCurrentUser();
      this.userDisplayName.set((user?.displayName || user?.email) ?? 'Usuario');
      this.userIsAnonymous.set(user?.isAnonymous ?? false);
    });
  }

  gotoHome() {
    this.router.navigate(['/home']);
  }

  async logout() {
    try {
      await this.authService.logout();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  }
}
